import { useState } from 'react';

export default function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const textarea = form.querySelector('textarea[name="message"]') as HTMLTextAreaElement;
    if (textarea && textarea.value.length > 500) {
      alert('訊息內容不可超過500字');
      return;
    }
    setIsSubmitting(true);
    const formData = new URLSearchParams();
    const elements = form.elements as HTMLFormControlsCollection;
    Array.from(elements).forEach((el) => {
      const input = el as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
      if (input.name) {
        formData.append(input.name, input.value);
      }
    });
    try {
      await fetch('https://readdy.ai/api/form/d6go4nipd4a8ta1leb1g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setSubmitted(true);
    } catch {
      // silent
    } finally {
      setIsSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div className="w-20 h-20 flex items-center justify-center bg-orange-100 rounded-full mb-6">
          <i className="ri-checkbox-circle-line text-5xl text-orange-500"></i>
        </div>
        <h3 className="text-2xl font-bold text-slate-900 mb-3">查詢已成功提交！</h3>
        <p className="text-slate-600 text-base">我們的團隊將於2個工作天內與您聯絡，感謝您的查詢。</p>
        <button
          onClick={() => { setSubmitted(false); setCharCount(0); }}
          className="mt-8 px-8 py-3 bg-orange-500 text-white font-semibold rounded-full hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          再次查詢
        </button>
      </div>
    );
  }

  return (
    <form
      id="contact-inquiry-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="space-y-5"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-1.5">
            姓名 <span className="text-orange-500">*</span>
          </label>
          <input
            type="text"
            name="name"
            required
            placeholder="請輸入您的姓名"
            className="w-full px-4 py-3 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-100 transition bg-white"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-1.5">
            電話 <span className="text-orange-500">*</span>
          </label>
          <input
            type="tel"
            name="phone"
            required
            placeholder="請輸入您的聯絡電話"
            className="w-full px-4 py-3 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-100 transition bg-white"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-semibold text-slate-700 mb-1.5">
          電郵地址 <span className="text-orange-500">*</span>
        </label>
        <input
          type="email"
          name="email"
          required
          placeholder="請輸入您的電郵地址"
          className="w-full px-4 py-3 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-100 transition bg-white"
        />
      </div>

      <div>
        <label className="block text-sm font-semibold text-slate-700 mb-1.5">
          機構 / 公司名稱
        </label>
        <input
          type="text"
          name="organization"
          placeholder="請輸入您的機構或公司名稱（如適用）"
          className="w-full px-4 py-3 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-100 transition bg-white"
        />
      </div>

      <div>
        <label className="block text-sm font-semibold text-slate-700 mb-1.5">
          查詢類別 <span className="text-orange-500">*</span>
        </label>
        <select
          name="inquiry_type"
          required
          className="w-full px-4 py-3 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-100 transition bg-white cursor-pointer"
        >
          <option value="">請選擇查詢類別</option>
          <option value="復康外展服務">復康外展服務</option>
          <option value="復康訓練器材及監測系統">復康訓練器材及監測系統</option>
          <option value="院舍改善工程">院舍改善工程</option>
          <option value="合作洽談">合作洽談</option>
          <option value="其他">其他</option>
        </select>
      </div>

      <div>
        <label className="block text-sm font-semibold text-slate-700 mb-1.5">
          查詢內容 <span className="text-orange-500">*</span>
        </label>
        <textarea
          name="message"
          required
          rows={5}
          maxLength={500}
          placeholder="請詳細描述您的查詢內容..."
          onChange={(e) => setCharCount(e.target.value.length)}
          className="w-full px-4 py-3 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-100 transition bg-white resize-none"
        />
        <p className={`text-xs mt-1 text-right ${charCount > 480 ? 'text-orange-500' : 'text-slate-400'}`}>
          {charCount} / 500
        </p>
      </div>

      <button
        type="submit"
        disabled={isSubmitting}
        className="w-full py-4 bg-orange-500 text-white font-bold text-base rounded-full hover:bg-orange-600 transition-all duration-300 flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer disabled:opacity-60 shadow-lg hover:shadow-xl"
      >
        {isSubmitting ? (
          <>
            <i className="ri-loader-4-line animate-spin text-xl"></i>
            <span>提交中...</span>
          </>
        ) : (
          <>
            <i className="ri-send-plane-line text-xl"></i>
            <span>提交查詢</span>
          </>
        )}
      </button>
    </form>
  );
}
